/* eslint-disable css-modules/no-unused-class, camelcase  */
import { FC, useEffect, useState } from 'react';
import { useGetCompletionData } from '@queries/platform/homepage';
import {
    selectIsCxUniversity,
    selectIsLeanUser,
    selectIsPLG,
    selectToken,
    selectUserUuid
} from '@redux/slices/userSlice';
import { useGetUsersLeaderboards, useGetTeamsLeaderboards } from '@queries/core/homepage';
import { coreService } from 'network-utils';
import { useSelector } from 'react-redux';
import styles from './home.module.scss';
import HomeTabs from './homeTabs/homeTabs';

const HomeContainer: FC<HomeContainerProps> = (props: HomeContainerProps) => {
    const { fullWidth, setCertificateCourseUuid, setVideoTutorialUuid, onContactUsClick, setIsCustomCourse } = props;
    const token = useSelector(selectToken);
    const userUuid = useSelector(selectUserUuid);
    const isLeanUser = useSelector(selectIsLeanUser);
    const isCxUniversityUser = useSelector(selectIsCxUniversity);
    const isPLG = useSelector(selectIsPLG);
    const leaderBoardLinesNumber = 3;
    const [completionRate, setCompletionRate] = useState<any>(null);
    const [usersLeaderboards, setUsersLeaderboards] = useState<coreService.HomeLeaderboardResponse | undefined>();
    const [teamsLeaderboards, setTeamsLeaderboards] = useState<coreService.HomeTeamLeaderboardResponse>();

    const { data: completionData, isLoading: isLoadingUserCompletion } = useGetCompletionData(
        userUuid,
        !isLeanUser && !isCxUniversityUser
    );
    const { isLoading: usersLeaderboardIsLoading, data: usersLeaderboardsData } = useGetUsersLeaderboards(token, {
        search: undefined,
        offset: 0,
        limit: leaderBoardLinesNumber,
        enableQuery: !isPLG
    });

    const { isLoading: teamsLeaderboardIsLoading, data: teamsLeaderboardsData } = useGetTeamsLeaderboards(token, {
        search: undefined,
        offset: 0,
        limit: leaderBoardLinesNumber,
        enableQuery: !isLeanUser && !isCxUniversityUser
    });

    useEffect(() => {
        if (!teamsLeaderboardsData) return;
        if ((teamsLeaderboardsData as any).success === false) return;
        setTeamsLeaderboards(teamsLeaderboardsData);
    }, [teamsLeaderboardsData]);

    useEffect(() => {
        if (!usersLeaderboardsData) return;
        if ((usersLeaderboardsData as any).success === false) return;
        setUsersLeaderboards(usersLeaderboardsData);
    }, [usersLeaderboardsData]);

    useEffect(() => {
        if (!completionData?.data) return;

        const completionRateResponse = completionData.data;
        const { primary_course, assigned_lessons, assessments } = completionRateResponse;
        const primaryCourseTmp = {
            totalLessons: primary_course.total_lessons,
            completionLesson: primary_course.completed_lessons,
            percent: primary_course.percent
        };

        const assignedLessonsTmp = {
            totalLessons: assigned_lessons.total_lessons,
            completionLesson: assigned_lessons.completed_lessons,
            percent: assigned_lessons.percent
        };

        const assessmentsTmp = {
            totalAssessments: assessments.total_assessments,
            completionAssessments: assessments.completed_assessments,
            percent: assessments.percent
        };

        const completionRateTmp = {
            primaryCourse: primaryCourseTmp,
            assignedLessons: assignedLessonsTmp,
            assessments: assessmentsTmp
        };

        setCompletionRate(completionRateTmp);
    }, [completionData]);

    return !usersLeaderboardIsLoading && !teamsLeaderboardIsLoading && !isLoadingUserCompletion ? (
        <div id="home-page" className={styles['home-wrapper-full-width']}>
            <HomeTabs
                setCertificateCourseUuid={setCertificateCourseUuid}
                setVideoTutorialUuid={setVideoTutorialUuid}
                onContactUsClick={onContactUsClick}
                fullWidth={fullWidth}
                showRightSide={Boolean(completionRate)}
                isLeanUser={isLeanUser}
                showTabs={!isCxUniversityUser}
                setIsCustomCourse={setIsCustomCourse}
                rightSideData={{
                    courseRate: completionRate?.primaryCourse,
                    lessonsRate: completionRate?.assignedLessons,
                    assessmentsRate: completionRate?.assessments,
                    teamsLeaderboard: teamsLeaderboards,
                    usersLeaderboard: usersLeaderboards,
                    onlyUsers: isLeanUser,
                    fullWidth
                }}
            />
        </div>
    ) : null;
};

interface HomeContainerProps {
    fullWidth: boolean;
    setCertificateCourseUuid: Function;
    setIsCustomCourse: Function;
    setVideoTutorialUuid: Function;
    onContactUsClick: Function;
}

export default HomeContainer;
